import { render, staticRenderFns } from "./advert-description.vue?vue&type=template&id=13315821"
import script from "./advert-description.vue?vue&type=script&lang=ts"
export * from "./advert-description.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports